import React, { useState } from "react"
import Loadable from "@loadable/component"
import { Link } from "gatsby"
import CTALink from "@components/elements/CTALink"
// import { propertiesSaleURL } from "@lib/urls"
// import { defaultAreaSlug } from "@common/constant"
import CloseIcon from "@components/icons/CloseIcon"
import BannerSearch from "@components/BannerSearch/BannerSearch"
import { isBrowser } from "@hooks/useLocation"
import "./SiteSearch.scss"
import { Container, Tabs, Tab } from "react-bootstrap"

const {
  parseResultsUrl,
} = require("../../gatsby-library-common/PropertySearchNew")

const LocalSiteSearch = Loadable(() => import("./LocalSiteSearch"))

const SiteSearch = ({ setToggleSearch }) => {
  const bannerRef = React.useRef(null)
  const [searchResult, setSearchResult] = useState("")

  const searchResultFunction = (result) => {
    setSearchResult(result)
  }

  const location = isBrowser ? window.location : ""
  const pageUrlData = parseResultsUrl(location)

  // console.log("pageUrlData ===>", pageUrlData)

  return (
    <div className="siteSearchWrapper">
      {/* <Tabs
        activeKey={activeKey}
        setActiveKey={setActiveKey}
        className="tab-header"
      >
        <Tab eventKey="site_search">Site Search</Tab>
        <Link
          to={`${propertiesSaleURL}${defaultAreaSlug}/`}
          className="tab-button"
        >
          Property Search
        </Link>
      </Tabs> */}
      <CloseIcon onClick={() => setToggleSearch(false)} color="secondary" />
      <Container>
        <h2>Search</h2>

        <Tabs defaultActiveKey="property_search" className="tab-header">
          <Tab eventKey="site_search" title="Site Search">
            <div className="siteSearchForm">
              <LocalSiteSearch searchResult={searchResultFunction} />
            </div>

            {Object.keys(searchResult).length > 0 && (
              <div className="service-box">
                {searchResult?.Pages?.length > 0 && (
                  <div className="box">
                    <h3>Pages ({searchResult?.Pages?.length})</h3>

                    <ul>
                      {searchResult.Pages.map((item) => {
                        if (item?.title) {
                          return (
                            <li key="">
                              <CTALink cta={item} label={item?.title} />
                            </li>
                          )
                        }
                        return ""
                      })}
                    </ul>
                  </div>
                )}

                {Object.keys(searchResult)
                  .filter((key) => key !== "Pages")
                  .map((key) => {
                    // console.log("item", key, searchResult[key]);
                    if (searchResult[key].length > 0) {
                      return (
                        <div className="box" key="">
                          <h3>
                            {key} ({searchResult[key].length})
                          </h3>

                          <ul>
                            {searchResult[key].map((item) => {
                              return (
                                <li key="">
                                  <Link to={item.menu.url}>{item.title}</Link>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      )
                    }
                    return ""
                  })}
              </div>
            )}
          </Tab>
          <Tab eventKey="property_search" title="Property Search">
            <div className="siteSearchForm">
              <BannerSearch
                bannerRef={bannerRef}
                // showFilter={showFilter}
                // setShowFilter={setShowFilter}
                setToggleSearch={setToggleSearch}
                areaVal={pageUrlData?.areaVal}
              />
            </div>
          </Tab>
        </Tabs>
        {/* <p>
          Search our services, people and news. If you&apos;re searching for
          properties, please{" "}
          <Link to={`${propertiesSaleURL}${defaultAreaSlug}/`}>click here</Link>
          .
        </p>

        <div className="siteSearchForm">
          <LocalSiteSearch searchResult={searchResultFunction} />
        </div>

        {Object.keys(searchResult).length > 0 && (
          <div className="service-box">
            <div className="box">
              {searchResult?.Pages?.length > 0 && (
                <>
                  <h3>Pages ({searchResult?.Pages?.length})</h3>

                  <ul>
                    {searchResult.Pages.map((item) => {
                      if (item?.title) {
                        return (
                          <li key="">
                            <CTALink cta={item} label={item?.title} />
                          </li>
                        )
                      }
                      return ""
                    })}
                  </ul>
                </>
              )}
            </div>

            {Object.keys(searchResult)
              .filter((key) => key !== "Pages")
              .map((key) => {
                // console.log("item", key, searchResult[key]);
                if (searchResult[key].length > 0) {
                  return (
                    <div className="box" key="">
                      <h3>
                        {key} ({searchResult[key].length})
                      </h3>

                      <ul>
                        {searchResult[key].map((item) => {
                          return (
                            <li key="">
                              <Link to={item.menu.url}>{item.title}</Link>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )
                }
                return ""
              })}
          </div>
        )} */}
      </Container>
    </div>
  )
}
export default SiteSearch
